var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37577_2272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12V14H4V12H3V14C3 14.2652 3.10536 14.5196 3.29289 14.7071C3.48043 14.8946 3.73478 15 4 15H12C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14V12H12Z",
    fill: "#273896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5L9.793 9.793L8.5 11.086V7H7.5V11.086L6.207 9.793L5.5 10.5L8 13L10.5 10.5ZM14 2V1H11V6H12V4H13.5V3H12V2H14ZM8.5 6H6.5V1H8.5C8.8977 1.0004 9.279 1.15856 9.56022 1.43978C9.84144 1.721 9.9996 2.1023 10 2.5V4.5C9.9996 4.8977 9.84144 5.279 9.56022 5.56022C9.279 5.84144 8.8977 5.9996 8.5 6ZM7.5 5H8.5C8.63261 5 8.75979 4.94732 8.85355 4.85355C8.94732 4.75979 9 4.63261 9 4.5V2.5C9 2.36739 8.94732 2.24021 8.85355 2.14645C8.75979 2.05268 8.63261 2 8.5 2H7.5V5ZM4.5 1H2V6H3V4.5H4.5C4.76509 4.4996 5.01922 4.39412 5.20667 4.20667C5.39412 4.01922 5.4996 3.76509 5.5 3.5V2C5.5 1.73478 5.39464 1.48043 5.20711 1.29289C5.01957 1.10536 4.76522 1 4.5 1ZM3 3.5V2H4.5L4.5005 3.5H3Z",
    fill: "#273896"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58331 13.1251V8.29764L5.70831 10.1726L5.11914 9.58347L7.99997 6.70264L10.8808 9.58347L10.2916 10.1726L8.41664 8.29764V13.1251H7.58331Z",
    fill: "#273896"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37577_2272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfUpload);
export default __webpack_public_path__ + "static/media/pdf_upload.5d1efd59e0f188c21ffd9e5fcc7781fe.svg";
export { ForwardRef as ReactComponent };